import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './App.css';
import { useAuth } from './AuthContext';

function SignUp() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { signUp } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validation
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);

    try {
      const { data, error } = await signUp(email, password, fullName);
      
      if (error) {
        setError(error.message || 'Failed to create account. Please try again.');
        setLoading(false);
        return;
      }

      if (data?.user) {
        setSuccess(true);
        setError('');
        // Redirect to account page after a short delay
        setTimeout(() => {
          navigate('/account');
        }, 2000);
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      setLoading(false);
    }
  };

  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

  return (
    <div className="main-bg">
      {!isMobile && (
        <header className="hero-section">
          <h1 className="site-title">Sign Up</h1>
          <p className="site-tagline">Create your account to get started</p>
        </header>
      )}
      <div className="auth-container">
        <div className="auth-card">
          <h2>Create Account</h2>
          <p className="auth-subtitle">Join Life Force Dynamics today</p>
          
          {error && <div className="auth-error">{error}</div>}
          {success && (
            <div className="auth-success">
              Account created successfully! Redirecting...
            </div>
          )}
          
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Enter your full name"
                required
                className="auth-input"
              />
            </div>
            
            <div className="auth-form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="auth-input"
              />
            </div>
            
            <div className="auth-form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Create a password (min. 6 characters)"
                required
                minLength={6}
                className="auth-input"
              />
            </div>
            
            <div className="auth-form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your password"
                required
                minLength={6}
                className="auth-input"
              />
            </div>
            
            <button 
              type="submit" 
              className="auth-submit-btn" 
              disabled={loading || success}
            >
              {loading ? 'Creating Account...' : success ? 'Account Created!' : 'Sign Up'}
            </button>
          </form>
          
          <div className="auth-footer">
            <p>
              Already have an account?{' '}
              <Link to="/login" className="auth-link">Sign in here</Link>
            </p>
          </div>
        </div>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default SignUp;


